import SpriteComponent from 'Component/Render/Sprite';
import { ICardsState } from 'State/Card/ICardState';
import { StartAnimationClip } from 'System/Animation/AnimationHelper';
import { Alpha } from 'System/Animation/Clip';
import { MathHelper } from 'Utility/MathHelper';
import CardSystem from '../../CardSystem';
import BaseCardModifierHandler from './BaseCardModifierHandler';

export default class FogModifierHandler extends BaseCardModifierHandler {
    public handleModifierInPlay(state: ICardsState, cardSystem: CardSystem) {
        super.handleModifierInPlay(state, cardSystem);

        const modifierStateData = this.getModifierStateData(state);

        const opacityLevels: number[] = [1, 0.75, 0.35];
        const endAlpha: number =
            opacityLevels[
                MathHelper.pingPong(
                    modifierStateData.properties.plays,
                    2
                )
            ];

        const fogContainer = this.modifier.find('fog_sprite');
        const fogSpriteComponent: SpriteComponent = fogContainer.getComponent(SpriteComponent);

        if (fogSpriteComponent.alpha !== endAlpha) {
            StartAnimationClip(new Alpha(
                fogContainer, {
                    startAlpha: fogSpriteComponent.alpha,
                    endAlpha,
                    duration: 250,
                }
            ));
        }
    }
}
